import { getBooleanishTruthy } from '@brandfolder/utilities';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { ButtonVariants } from '../../../../enums/button.js';

const BaseButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { 'aria-disabled': ariaDisabled, className, disabled, loading, onClick, type = 'button', variant = ButtonVariants.None, ...otherProps } = props;
    const isDisabled = getBooleanishTruthy(ariaDisabled) || disabled || loading || undefined;
    /**
   * <form> with a <button type="submit"> still submits with aria-disabled="true",
   * actual disabled attribute is needed in this situation
   * */ const submitDisabled = type === 'submit' && isDisabled;
    return /*#__PURE__*/ React.createElement("button", {
        ...otherProps,
        "aria-disabled": isDisabled,
        className: classnames({
            'bf-button': true,
            [`bf-button__${variant}`]: variant !== ButtonVariants.None,
            [`${className}`]: !!className
        }),
        disabled: submitDisabled,
        ref: ref,
        onClick: isDisabled ? undefined : onClick,
        type: type
    });
});

export { BaseButton };
//# sourceMappingURL=base-button.js.map
